import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  expression: 'happy',        // 'idle' | 'happy' | 'wink' | 'talk' | 'excited'
  message: 'Hoş geldin! İstediğin satış türünü seçebilirsin.',
  showBubble: true,
  position: null, // { left:number, top:number }  YENİ
  pushCount: 0, // YENİ: itme sayacı
};

const cuteStarSlice = createSlice({
  name: 'cuteStar',
  initialState,
  reducers: {
    setExpression: (state, action) => { state.expression = action.payload; },
    setMessage: (state, action) => { state.message = action.payload; },
    setShowBubble: (state, action) => { state.showBubble = action.payload; },
    setPosition: (state, action) => { state.position = action.payload; }, // YENİ
    incrementPush: (state) => { state.pushCount += 1; },
    resetPush: (state) => { state.pushCount = 0; },
    updateStar: (state, action) => {
      const { expression, message, showBubble, position, pushCount } = action.payload || {};
      if (expression !== undefined) state.expression = expression;
      if (message !== undefined) state.message = message;
      if (showBubble !== undefined) state.showBubble = showBubble;
      if (position) state.position = position;
      if (pushCount !== undefined) state.pushCount = pushCount;
    },
    resetStar: () => initialState
  }
});

export const cuteStarActions = cuteStarSlice.actions;
export default cuteStarSlice.reducer;

// Selectors
export const selectStarExpression = state => state.cuteStar?.expression;
export const selectStarMessage = state => state.cuteStar?.message;
export const selectStarShowBubble = state => state.cuteStar?.showBubble;
export const selectStarPosition = state => state.cuteStar?.position;
export const selectStarPushCount = state => state.cuteStar?.pushCount || 0;
